import {
  MantineProvider as MMantineProvider,
  type MantineProviderProps,
} from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { theme as defaultTheme, resolver } from './theme';

export function MantineProvider({
  children,
  ...props
}: PropsWithChildren<MantineProviderProps>) {
  return (
    <MMantineProvider
      theme={defaultTheme}
      cssVariablesResolver={resolver}
      {...props}
    >
      {children}
    </MMantineProvider>
  );
}
